import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Loader from 'components/Loader'
import Item from 'components/PosAccounts/Item'
import Section from 'components/Section'
import PosAccountsDetailes from 'components/PosAccounts/Form'

import { getIsLoadingAttendants } from 'store/Attendants/selectors'

const List = ({ attendants }) => {
  const isLoadingAttendants = useSelector(getIsLoadingAttendants)
  const { state: locationState } = useLocation()

  const isModal = !isEmpty(locationState?.posAccountUuid)
  const posAccountUuid = locationState?.posAccountUuid

  const isLoading = isLoadingAttendants && !isModal

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <Section className="item-list section">
        {attendants?.map(
          ({
            name,
            phone,
            email,
            pinNumber,
            deactivatedAt,
            uuid,
            id,
            employeeRole,
          }) => (
            <Item
              name={name}
              phone={phone}
              email={email}
              pinNumber={pinNumber}
              deactivatedAt={deactivatedAt}
              key={uuid}
              id={id}
              employeeRole={employeeRole}
              uuid={uuid}
            />
          )
        )}
      </Section>
      {isModal && <PosAccountsDetailes uuid={posAccountUuid} />}
    </>
  )
}

export default List
